<template>
    <!-- Contact Us -->
    <section>
        <div class="container">
            <div class="row justify-center">
                <div class="col-xs-12 col-md-7">
                    <div class="text-title">Contact Us</div>
                    <q-card>
                        <q-card-section v-if="error">
                            <div class="row items-center q-col-gutter-sm">
                                <div class="col-auto justify-center">
                                    <q-icon name="mdi-email-alert" color="negative" size="xl" />
                                </div>
                                <div class="col">
                                    <span class="text-title text-negative">Your message was not sent</span>
                                </div>
                            </div>
                            <div class="row q-my-md">
                                <div class="col">
                                    There was a problem sending your message, please try again at a later time or for further technical assistance, please call 403.247.8566.
                                </div>
                            </div>
                            <div class="row">
                                <q-btn color="primary" icon="mdi-home"
                                       label="Return Home"
                                       to="/"
                                       class="col-xs-12 col-sm-auto" />
                            </div>
                        </q-card-section>
                        <q-card-section v-else-if="sent">
                            <div class="row items-center q-col-gutter-sm">
                                <div class="col-auto justify-center">
                                    <q-icon name="mdi-email-check" color="positive" size="xl" />
                                </div>
                                <div class="col">
                                    <span class="text-title text-positive">Your message has been sent!</span>
                                </div>
                            </div>
                            <div class="row q-my-md">
                                <div class="col">
                                    Your message or request has been submitted. One of our staff members should be following
                                    up with you shortly to assist you. Click 'Continue' to return to our <router-link to="/">Home Page</router-link>.
                                </div>
                            </div>
                            <div class="row">
                                <q-btn color="primary"
                                       label="Continue"
                                       to="/"
                                       class="col-xs-12 col-sm-auto" />
                            </div>
                        </q-card-section>
                        <q-card-section v-else>
                            <div class="q-mb-lg">
                                <span class="text-subtitle">Avenir Software Inc.</span>

                                <a href="https://goo.gl/maps/NeiBdCg1T3B2" target="_blank" class="text-muted">
                                    <div class="row">
                                        <i class="mdi mdi-map-marker q-mr-xs"></i>
                                        212 - 4935 40th Ave NW
                                    </div>
                                    <div class="row">Calgary, Alberta, Canada, T3A 2N1</div>
                                </a>

                                <div class="row q-mt-md"><i class="mdi mdi-phone q-mr-xs"></i> Phone: +1 403.247.8566</div>
                            </div>
                            <p>Have a question or need some assistance? Feel free to send us a message.</p>

                            <p class="text-caption">Your information will not be shared - see our <router-link to="/privacy">Privacy Policy</router-link> for details.</p>

                            <q-form @submit.prevent="onSubmit" autocomplete="off">
                                <div class="q-gutter-y-md column">
                                    <q-input v-model.trim="form.name"
                                             label="Name"
                                             autocomplete="on" name="name"
                                             :rules="[ val => $v.form.name.required || 'Name is required' ]"
                                             outlined dense
                                             hide-bottom-space>
                                        <template v-slot:prepend>
                                            <q-icon name="mdi-account" />
                                        </template>
                                    </q-input>
                                    <q-input v-model.trim="form.email"
                                             label="Email"
                                             autocomplete="on" name="email"
                                             :rules="[ val => $v.form.email.required || 'Email is required', val => $v.form.email.email || 'Not a valid email format' ]"
                                             outlined dense
                                             hide-bottom-space>
                                        <template v-slot:prepend>
                                            <q-icon name="mdi-email" />
                                        </template>
                                    </q-input>
                                    <q-input v-model.trim="form.subject"
                                             label="Subject"
                                             autocomplete="on" name="subject"
                                             :rules="[ val => $v.form.subject.required || 'Subject is required' ]"
                                             outlined dense
                                             hide-bottom-space>
                                        <template v-slot:prepend>
                                            <q-icon name="mdi-text" />
                                        </template>
                                    </q-input>
                                    <q-input v-model.trim="form.message"
                                             label="Message"
                                             autocomplete="on" name="message"
                                             :rules="[ val => $v.form.message.required || 'Message is required' ]"
                                             outlined dense
                                             type="textarea"
                                             hide-bottom-space>
                                        <template v-slot:prepend>
                                            <q-icon name="mdi-message-text" />
                                        </template>
                                    </q-input>
                                    <div class="row q-mt-sm q-col-gutter-sm justify-between">
                                        <div class="col-xs-12 col-sm-auto">
                                            <q-btn color="primary" icon="mdi-send"
                                                   :label="sendContactEmailPending ? 'Sending...' : 'Send Message'"
                                                   type="submit"
                                                   class="full-width" />

                                        </div>
                                        <div class="col-xs-12 col-sm-auto">
                                            <span v-if="showVerify" class="text-caption text-negative">
                                                Unable to verify using reCAPTCHA. <br /> Please try again later, or email us directly at: <br /> support@avenir-software.com.
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </q-form>
                        </q-card-section>

                        <q-inner-loading :showing="sendContactEmailPending">
                            <div>
                                <q-spinner color="primary"
                                           :thickness="2"
                                           size="3em" />
                            </div>
                        </q-inner-loading>
                    </q-card>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    import { required, email } from 'vuelidate/lib/validators'
    import { mapState } from 'vuex'


    export default {
        name: 'contact',
        components: {
        },
        data() {
            return {
                recaptchaVerified: false,
                showVerify: false,
                sent: false,
                error: false,
                form: {
                    name: '',
                    email: '',
                    subject: '',
                    message: '',
                },
            }
        },
        validations: {
            form: {
                name: { required },
                email: { required, email },
                subject: { required },
                message: { required },
            }
        },
        methods: {
            onSubmit() {
                this.$v.form.$touch()
                if (this.$v.form.$pending || this.$v.form.$error) return

                this.$recaptcha('submit').then(token => {
                    this.$store.dispatch('verifyRecaptchaToken', token).then(() => {
                        this.recaptchaVerified = this.verifyRecaptchaTokenData;

                        if (!this.recaptchaVerified) {
                            this.showVerify = true;
                            return;
                        }

                        this.$store.dispatch('sendContactEmail', this.form).then(() => {
                            this.sent = true
                        }).catch((err) => {
                            this.error = true
                        })
                    });
                });

            },
        },
        computed: {
            ...mapState([
                'sendContactEmailData',
                'sendContactEmailPending',

                'verifyRecaptchaTokenData',
                'verifyRecaptchaTokenPending',
            ]),
        },
        created() {
            this.recaptchaVerified = false
            this.showVerify = false
            this.sent = false
            this.error = false
            if (this.$route.query.subject)
                this.form.subject = this.$route.query.subject
        },
    }
</script>
